/* import __COLOCATED_TEMPLATE__ from './vat-field.hbs'; */
/* RESPONSIBLE TEAM: team-billing */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import nonEuTaxEligibleCountries from 'embercom/lib/non-eu-tax-eligible-countries';

export interface Args {
  setVatNumber: (vatNumber: Event) => void;
  countryCode?: string;
}

interface Signature {
  Args: Args;
}

export default class VatField extends Component<Signature> {
  @service declare intl: IntlService;

  /**
   * Returns the appropriate placeholder translation key based on the country code
   */
  get placeholderKey(): string {
    let { countryCode } = this.args;
    let baseKey = 'signup.teams.pricing5.annual-plans.credit-card-details';

    let placeholderCountry = 'default';
    if (countryCode && nonEuTaxEligibleCountries.includes(countryCode)) {
      placeholderCountry = countryCode.toLowerCase();
    }

    return `${baseKey}.${placeholderCountry}-tax-number-placeholder`;
  }

  /**
   * Returns the translated placeholder text
   */
  get placeholder(): string {
    return this.intl.t(this.placeholderKey, { countryCode: this.args.countryCode });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Stripe::VatField': typeof VatField;
  }
}
